(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurora-order-notice"]) return;
  try {
    
  if (!customElements.get('aurora-order-notice')) {
    customElements.define('aurora-order-notice', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;

        const key = `aurora-order-notice-2026-09-24-${this.dataset.themeId}`;
        const designMode = Boolean(window.Shopify?.designMode);
        let dismissed = false;
        try {
          dismissed = sessionStorage.getItem(key) === 'dismissed';
        } catch {}

        const open = () => {
          if (dialog.open || !this.isConnected) return;
          if (!designMode && dismissed) return;
          dialog.showModal();
        };

        dialog.addEventListener('close', () => {
          if (designMode) return;
          dismissed = true;
          try {
            sessionStorage.setItem(key, 'dismissed');
          } catch {}
        }, { signal });

        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            dialog.close();
          }
        }, { signal });

        if (designMode) {
          document.addEventListener('shopify:section:select', event => {
            if (event.detail.sectionId === this.dataset.sectionId) open();
          }, { signal });
          document.addEventListener('shopify:section:deselect', event => {
            if (event.detail.sectionId === this.dataset.sectionId) dialog.close();
          }, { signal });
        } else if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', open, { once: true, signal });
        } else {
          open();
        }
      }

      disconnectedCallback() {
        this.querySelector('dialog')?.close();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
